import type { Messages } from '../i18n';
import { ApiError } from './api';

/**
 * The sentence staff read for a failed request (ADR 0005): the code's own
 * sentence, or the one for its status. The problem's detail is English, for
 * integrators and the log, and is shown only where it is a payment service's
 * own words, which the code's entry quotes (docs/15 §6).
 */
export function problemText(t: Messages, error: unknown): string {
    if (!(error instanceof ApiError)) return t.genericError;
    return codedText(t, error) ?? t.errors.status[error.status as keyof typeof t.errors.status] ?? t.genericError;
}

/**
 * The refusal's own code, for the rare screen that answers one with more than
 * words — a spent sign-in that can only start again. The sentence still comes
 * from problemText.
 */
export function problemCode(error: unknown): string | undefined {
    return error instanceof ApiError ? error.code : undefined;
}

function codedText(t: Messages, error: ApiError): string | undefined {
    const code = error.code;
    const entry: string | ((quote: string) => string) | undefined = code ? t.errors.problems[code as keyof typeof t.errors.problems] : undefined;
    // An entry that takes the quote is a refusal in a service's own words.
    if (typeof entry === 'function') return error.problem.detail ? entry(error.problem.detail) : undefined;
    return entry;
}
